import { demoUser, RootState } from '@hypexone/uicore';
import React from 'react';
import { connect } from 'react-redux';

type SportStatProps = {
  eventID: string;
  competitionId: string;
  providerUrl: string;
  balance: number;
  channelId: string;
  clientIp: string
};

export const getUserCreationTime = () => {
  if (sessionStorage.getItem('jwt_token')) {
    const claim = sessionStorage.getItem('jwt_token').split('.')[1];
    return JSON.parse(window.atob(claim)).ctime;
  }
  return null;
};

export const showIplStream = () => {
  const creationTime = getUserCreationTime(); // in seconds
  const inputDate = new Date(creationTime * 1000); // convert to milliseconds
  const targetDate = new Date('2025-02-10T23:59:59'); // end of 10th Feb 2025

  return (inputDate <= targetDate);
}

const LiveStream: React.FC<SportStatProps> = (props) => {
  const { eventID, providerUrl, channelId, clientIp } = props;
  if (demoUser()) {
    return null;
  }

  return (
    <div className="cricket-live-stream-ctn border border-black mb-[10px]">
      {providerUrl && providerUrl != '-' ? (
        <iframe
          title="cric-live-stream"
          id="fp_embed_player"
          src={providerUrl}
          className='w-full'
          allowFullScreen={true}
        ></iframe>
      ) :
        <iframe
          title="mob-live-stream"
          allowFullScreen={false}
          src={`https://s.strike46.com/?eventId=${eventID?.split(":").join("_")}`}
          className='w-full h-[247px]'
          sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
        ></iframe>
      }
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    balance: state.auth.balanceSummary.balance,
  };
};


export default connect(mapStateToProps, null)(LiveStream);
